export enum Brand {
  hisense = 'hisense',
  all = 'all',
}

export type BrandKey = keyof typeof Brand;
